export * from './baMultiCheckbox.component'



// WEBPACK FOOTER //
// ./src/app/theme/components/baMultiCheckbox/index.ts